import { useWindowSize } from 'owa-react-hooks/lib/useWindowSize';

export const enum OptionLayout {
    /**
     * Categories, subcategories, and settings are laid out in three columns
     */
    ThreeColumn,
    /**
     * Categories and settings are laid out in two columns, with subcategories available in a flyout
     */
    TwoColumn,
    /**
     * Settings laid out in a single column, with categories and subcategories available in a combined flyout
     */
    OneColumn,
    /**
     * Settings laid out in a single column, with categories and subcategories available in separate flyouts
     */
    OneColumnNarrow,
}

export function useOptionLayout(): OptionLayout {
    const { width } = useWindowSize();
    if (width >= 780) {
        return OptionLayout.ThreeColumn;
    } else if (width >= 536) {
        return OptionLayout.TwoColumn;
    } else if (width >= 436) {
        return OptionLayout.OneColumn;
    } else {
        return OptionLayout.OneColumnNarrow;
    }
}
